var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Avatar, Col, Flex, Row, Select, Typography, Grid, theme } from "antd";
import { EVENT_ACTIONS, track } from "./../../../lib/gtag.js";
import { ReactComponent as Calendar } from "./../../../assets/icons/calendar.svg";
import { ReactComponent as ArrowDown } from "./../../../assets/icons/arrow-down.svg";
import FavoritesComponent from "./../../../components/favoritesComponent/FavoritesComponent.js";
import { FAVORITE_CATEGORIES } from "./../../../components/favoritesComponent/favoritesService.js";
const { Title } = Typography;
const { useBreakpoint } = Grid;
const LeagueHeader = ({
  iconUrl,
  name,
  seasons,
  currentSeason,
  setCurrentSeason,
  isFavorite,
  itemId,
  showFavoritesComponent = true,
  styles = {},
  children
}) => {
  var _a;
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  const seasonOptions = useMemo(
    () => {
      var _a2;
      return (_a2 = seasons == null ? void 0 : seasons.map((season) => ({
        value: season.id,
        label: season.name,
        isCurrent: season.isCurrent
      }))) != null ? _a2 : [];
    },
    [seasons]
  );
  const onChange = (seasonId) => {
    setCurrentSeason(seasons.find((season) => season.id === seasonId));
    track(EVENT_ACTIONS.CHANGE_SEASON);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "content-gray-box league-header",
      style: { paddingBottom: 0 },
      children: [
        /* @__PURE__ */ jsxs(
          Row,
          {
            justify: "space-between",
            align: "middle",
            style: { marginBottom: screens.md ? 16 : 12 },
            children: [
              /* @__PURE__ */ jsx(Col, { xs: 24, sm: 12, md: 12, children: /* @__PURE__ */ jsxs(
                Flex,
                {
                  justify: screens.md ? "start" : "space-between",
                  align: "center",
                  children: [
                    /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, children: [
                      /* @__PURE__ */ jsx(
                        Avatar,
                        {
                          src: iconUrl,
                          shape: "square",
                          size: screens.md ? 64 : 26,
                          style: {
                            borderRadius: 0,
                            flexShrink: 0
                          }
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        Title,
                        {
                          level: 3,
                          style: {
                            margin: 0,
                            fontSize: screens.md ? token.fontSizeHeading3 : token.fontSizeXL
                          },
                          children: name
                        }
                      )
                    ] }),
                    !screens.md && showFavoritesComponent && /* @__PURE__ */ jsx(
                      FavoritesComponent,
                      {
                        category: FAVORITE_CATEGORIES.LEAGUE,
                        itemId,
                        isFavorite
                      }
                    )
                  ]
                }
              ) }),
              /* @__PURE__ */ jsx(
                Col,
                {
                  xs: 24,
                  sm: 12,
                  md: 12,
                  style: {
                    marginTop: screens.xs && !screens.sm ? 16 : 0,
                    textAlign: screens.md ? "right" : "left"
                  },
                  children: /* @__PURE__ */ jsxs(
                    Flex,
                    {
                      align: "center",
                      justify: screens.md ? "end" : "start",
                      gap: 20,
                      children: [
                        /* @__PURE__ */ jsx(
                          Select,
                          {
                            defaultValue: (_a = seasonOptions.find((s) => s.isCurrent)) == null ? void 0 : _a.value,
                            value: currentSeason == null ? void 0 : currentSeason.id,
                            style: __spreadValues({
                              width: "max-content",
                              height: screens.md ? 48 : 30,
                              fontSize: screens.md ? token.fontSize : token.fontSizeXS
                            }, styles.select || {}),
                            options: seasonOptions,
                            onChange,
                            prefix: /* @__PURE__ */ jsx(
                              Calendar,
                              {
                                style: {
                                  width: screens.md ? 24 : 16,
                                  height: screens.md ? 24 : 16
                                },
                                className: "stroke-base"
                              }
                            ),
                            suffixIcon: /* @__PURE__ */ jsx(
                              ArrowDown,
                              {
                                className: "stroke-base",
                                style: {
                                  width: screens.md ? 24 : 16,
                                  height: screens.md ? 24 : 16
                                }
                              }
                            )
                          }
                        ),
                        screens.md && showFavoritesComponent && /* @__PURE__ */ jsx(
                          FavoritesComponent,
                          {
                            category: FAVORITE_CATEGORIES.LEAGUE,
                            itemId,
                            isFavorite
                          }
                        )
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        children
      ]
    }
  );
};
var stdin_default = memo(LeagueHeader);
export {
  stdin_default as default
};
